module.exports = __webpack_public_path__ + "static/media/icon-reader.6b4f4213.svg";